import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsCard = ({ title, value, change, changeType, icon, color = "primary" }) => {
  const getColorClasses = () => {
    switch (color) {
      case 'success':
        return 'from-success/10 to-success/5 border-success/20';
      case 'warning':
        return 'from-warning/10 to-warning/5 border-warning/20';
      case 'error':
        return 'from-error/10 to-error/5 border-error/20';
      default:
        return 'from-primary/10 to-primary/5 border-primary/20';
    }
  };

  const getIconColor = () => {
    switch (color) {
      case 'success':
        return 'var(--color-success)';
      case 'warning':
        return 'var(--color-warning)';
      case 'error':
        return 'var(--color-error)';
      default:
        return 'var(--color-primary)';
    }
  };

  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  return (
    <div className={`bg-gradient-to-br ${getColorClasses()} border rounded-xl p-6 hover:shadow-md transition-all duration-200`}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-muted-foreground mb-1">{title}</p>
          <p className="text-2xl font-bold text-foreground mb-2">{value}</p>
          {change && (
            <div className="flex items-center space-x-1">
              <Icon 
                name={changeType === 'positive' ? 'TrendingUp' : changeType === 'negative' ? 'TrendingDown' : 'Minus'} 
                size={14} 
                className={getChangeColor()}
              />
              <span className={`text-sm font-medium ${getChangeColor()}`}>
                {change}
              </span>
            </div>
          )}
        </div>
        <div className="w-12 h-12 rounded-lg bg-white/10 flex items-center justify-center">
          <Icon name={icon} size={24} color={getIconColor()} />
        </div>
      </div>
    </div>
  );
};

export default MetricsCard;